import TypeToReducer from 'type-to-reducer';

import { normalize, schema } from 'normalizr';

import {
  GET_ASSET_LEVEL,
  SET_ASSET_LEVEL_PAGINATION,
  SET_ASSET_LEVEL_FILTERS,
  RESET_ASSET_LEVEL,
  TOGGLE_ASSET_LEVEL,
} from 'asset_level/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

export const asset_level = new schema.Entity('asset_level');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'amount'],
    // columnSearch: ["key", "name"],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { asset_level: {} },
  result: { asset_level: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ asset_level: payload.records }, { asset_level: [asset_level] });

  return { ...state, isLoading: false, pagination, ...normalized };
};
export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    asset_level: {
      ...state.entities.asset_level,
      [meta.id]: { ...state.entities.asset_level[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    asset_level: {
      ...state.entities.asset_level,
      [meta.id]: { ...state.entities.asset_level[meta.id], isLoading: true },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    asset_level: {
      ...state.entities.asset_level,
      [payload.asset_level.id]: { ...payload.asset_level, isLoading: false },
    },
  },
});

const asset_levelListReducers = {
  [GET_ASSET_LEVEL]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_ASSET_LEVEL_PAGINATION]: setPagination,
  [SET_ASSET_LEVEL_FILTERS]: setFilters,
  [RESET_ASSET_LEVEL]: reset,
  [TOGGLE_ASSET_LEVEL]: {
    [PENDING]: togglePending,
    [REJECTED]: toggleRejected,
    [FULFILLED]: toggleFulfilled,
  },
};

export default TypeToReducer(asset_levelListReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/reducers/asset_level_list_reducers.js